import React from "react";
import Hero from "../Sections/Hero/Hero";
import Specials from "../Sections/Specials/Specials";
import Testimonials from "../Sections/Testimonials/Testimonials";
import About from "../Sections/About/About";

const Home = () => {
  return (
    <>
      <Hero />
      <Specials />
      <Testimonials />
      <About />
    </>
  );
};
export default Home;
